export const GET_ENROLLMENT_CONTEXT_QUERY_KEY = ['enrollmentContext'] as const;

export const ENROLLMENT_CONTEXT_ENDPOINT = '/enrollments/contexts';

export const ENROLLMENT_CONTEXT_SUCCESS = 'success';
export const NEW_HIRE_ENROLLMENT_TYPE = 'initial';
export const OPEN_ENROLLMENT_TYPE = 'open';
export const LIFE_EVENT_ENROLLMENT_TYPE = 'life_event';
export const DUAL_ENROLLMENT_TYPE = 'dual';
export const ENROLLMENT_COMPLETE_STATUS = ['not_open'];
export const ENROLLMENT_STARTED_STATUS = 'started';

export const WELCOME_HEADER_INDEX = 0;
export const LIFE_EVENT_HEADER_INDEX = 1;
export const OPEN_ENROLLMENT_HEADER_INDEX = 2;
export const CONTINUE_HEADER_INDEX = 3;

export const NEW_HIRE_BODY_INDEX = 0;
export const LIFE_EVENT_BODY_INDEX = 1;
export const OPEN_ENROLLMENT_BODY_INDEX = 2;
export const DUAL_ENROLLMENT_BODY_INDEX = 3;
export const CONTINUE_BODY_INDEX = 4;
